import(/* webpackMode: "eager" */ "/vercel/path0/src/app/ai-plan/page.tsx");
